import Vue from 'vue'
import Vuex from 'vuex'
import operate from './modules/operate'
import user from './modules/user'
import setting from './modules/setting'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        operate,
        user,
        setting
    }
})
